/*jshint esversion: 6 */
import store from '@/store/index';

function Project(payload) {
  let route = {
      path: '/projects/:project_id',
      name: 'Project',
      component: () => import( /* webpackChunkName: "Project" */ '@/views/Project/Project.view.vue'),
      props: (route) => {
        return {
          project_id: parseInt(route.params.project_id),
        };
      },
      redirect: {
        name: 'ProjectTaktPlan'
      },
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
          store.dispatch('Project/projectLoading', true);
          store.dispatch('Ultra/requestUObject', {
            url: [
              {projects: to.params.project_id},
              {'showWithEntitiesNormalized': ''}
            ]
          }).then(() => {
            if (!store.getters['Auth/isCloudPrint']) {
              let promises = [
                store.dispatch('Project/requestProjectPermissions', {
                  project_id: to.params.project_id
                }),
                // milestones
                // store.dispatch('Ultra/requestUObject', {
                //   url: [
                //     {projects: to.params.project_id},
                //     {milestones: ''},
                //     {'showWithEntitiesNormalized': ''}
                //   ]
                // }),
                //pmilestones? Und hier alle stati callen
                // store.dispatch('Message/requestMessagesProjectActive', {
                //   project_id: to.params.project_id
                // }),
                // store.dispatch('Project/requestProjectInformation', {
                //   project_id: to.params.project_id
                // }),
              ];
              Promise.all(promises)
              .then(() => {
                store.dispatch('Project/projectLoading', false);
                next();
              });
            } else {
              // milestones
              // store.dispatch('Ultra/requestUObject', {
              //   url: [
              //     {projects: to.params.project_id},
              //     {milestones: ''},
              //     {'showWithEntitiesNormalized': ''}
              //   ]
              // }).then(() => {
              // });
                store.dispatch('Project/projectLoading', false);
                next();
            }
          });
      },
    };
    if (payload && payload.children) {
      route.children = payload.children;
    }
  return route;
}
export default Project;
